import { Modal } from "antd";
import React from "react";
import "./LoginModal.css";

const LoginModal = ({ visible, onCancel, onRegister, onLogin }) => {
  // 检测是否为移动端
  const isMobile = window.innerWidth <= 768;

  return (
    <Modal
      title={<span className="login-modal-title">登录后更精彩</span>}
      open={visible}
      onCancel={onCancel}
      footer={null}
      width={isMobile ? "90%" : 600}
      centered
      bodyStyle={{
        padding: isMobile ? "20px" : "30px",
        background: "linear-gradient(135deg, #fff2f3 0%, #ffdde6 100%)",
        borderRadius: "8px",
      }}
      className="login-modal-container"
    //   closeIcon={
    //     <span
    //       className="login-modal-close-icon"
    //       style={{
    //         boxShadow: "none !important",
    //         margin: "0",
    //         padding: "0",
    //         display: "flex",
    //         alignItems: "center",
    //         justifyContent: "center",
    //         height: "24px",
    //         width: "24px",
    //         borderRadius: "50%",
    //         backgroundColor: "transparent",
    //         cursor: "pointer",
    //         transition: "all 0.3s ease",
    //       }}
    //     >
    //       ×
    //     </span>
    //   }
    >
      <div className="login-modal-content">
        <div className="login-modal-grid">
          <div className="login-modal-column">
            <div className="login-modal-item">
              <span className="login-modal-icon">📥</span>
              <span className="login-modal-text">商品资料下载</span>
            </div>
            <div className="login-modal-item">
              <span className="login-modal-icon">🔥</span>
              <span className="login-modal-text">爆款素材案例</span>
            </div>
            <div className="login-modal-item">
              <span className="login-modal-icon">🚚</span>
              <span className="login-modal-text">一件代发支持</span>
            </div>
          </div>
          <div className="login-modal-column">
            <div className="login-modal-item">
              <span className="login-modal-icon">🎤</span>
              <span className="login-modal-text">代播/代拍支持</span>
            </div>
            <div className="login-modal-item">
              <span className="login-modal-icon">🎁</span>
              <span className="login-modal-text">新品/样品申领</span>
            </div>
            <div className="login-modal-item">
              <span className="login-modal-icon">🤝</span>
              <span className="login-modal-text">团队/工厂合作</span>
            </div>
          </div>
        </div>
      </div>

      <div className="login-modal-buttons">
        <button
          className="login-modal-button login-modal-register"
          onClick={onRegister}
          style={{
            background: "linear-gradient(135deg, #1677ff 0%, #ff7e5f 100%)",
            border: "none",
            color: "#ffffff",
            boxShadow: "0 4px 12px rgba(254, 32, 98, 0.3)",
          }}
          onMouseEnter={(e) => {
            e.target.style.boxShadow = "0 6px 16px rgba(254, 32, 98, 0.4)";
            e.target.style.transform = "translateY(-2px)";
          }}
          onMouseLeave={(e) => {
            e.target.style.boxShadow = "0 4px 12px rgba(254, 32, 98, 0.3)";
            e.target.style.transform = "translateY(0)";
          }}
        >
          立即注册
        </button>
        <button
          className="login-modal-button login-modal-login"
          onClick={onLogin}
          style={{
            background: "linear-gradient(135deg, #1677ff 0%, #ff7e5f 100%)",
            border: "none",
            color: "#ffffff",
            boxShadow: "0 4px 12px rgba(254, 32, 98, 0.3)",
          }}
          onMouseEnter={(e) => {
            e.target.style.boxShadow = "0 6px 16px rgba(254, 32, 98, 0.4)";
            e.target.style.transform = "translateY(-2px)";
          }}
          onMouseLeave={(e) => {
            e.target.style.boxShadow = "0 4px 12px rgba(254, 32, 98, 0.3)";
            e.target.style.transform = "translateY(0)";
          }}
        >
          马上登录
        </button>
      </div>
    </Modal>
  );
};

export default LoginModal;
